import { dataAuditApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { CompanyResponse } from 'src/types';

export const getCompanyListAll = (config: AxiosRequestConfig = {}) =>
  dataAuditApi.get<CompanyResponse[]>('/api/v1/companies/all', config);
